import { Injectable } from "@angular/core";
import { AuthenticationService, Token } from '@mitel/cloudlink-sdk/authentication';
import { PolicyTestRequest, PolicyTestResponse } from '@mitel/cloudlink-sdk/authentication';
import { CloudLinkService } from "./cloudlink.service";

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    public auth: AuthenticationService;

    constructor(
        cloudlinkService: CloudLinkService
    ) {
        this.auth = cloudlinkService.authenticationService;
    }

    public getPartnerToken(): Token
    {
        let tokenStr = localStorage.getItem('@mitel/token.original_token');
        if ( tokenStr )
            return  JSON.parse(tokenStr); 

        return null;
    }

    assumeRole( newRole: string, newAccountId: string ): Promise<Token>
    {
        console.log("ASSUME ROLE", newAccountId);
        return this.auth.assumeRole({role: newRole, accountId: newAccountId}).then(response => response?.body);
    }

    revertRole(): Promise<Token>{
        if ( this.getPartnerToken() != null )
        {
            console.log("REVERT ROLE");
            return this.auth.revertRole();
        }
    }
    
    testPolicy(request: PolicyTestRequest): Promise<PolicyTestResponse> {
        return this.auth.testPolicy(request).then(response => response?.body);
    }
}

